/**
 * @copyright Copyright 2020 Epic Systems Corporation
 * @file LocaleLink component
 * @author Dustin Gage
 */

import React, { memo, useCallback, ReactElement, MouseEvent } from "react";
import { ILocaleAndName } from "../../types";

interface IProps {
	locale: ILocaleAndName;
}

export const LocaleLink = memo(function LocaleLink(props: IProps): ReactElement {
	const { locale } = props;
	const { name, key } = locale;

	const handleLocaleChange = useCallback(
		(event: MouseEvent<HTMLAnchorElement>) => {
			window.location.search = `?lang=${key}`;
			event.preventDefault();
		},
		[locale],
	);

	return (
		<a className="dropdown-item" href="#" onClick={handleLocaleChange}>
			{name}
		</a>
	);
});
